// extracted by mini-css-extract-plugin
module.exports = {"container":"Memory_container__G_gN9","section":"Memory_section__3S1RP"};